import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

import "./chip.scss";

export const Chip = ({ icon, label, value, onClick, onClear, disabled }) => {
    const chipClasses = classNames({
        chip: true,
        "-active": !!value,
        " -disabled": disabled,
    });
    const handleClear = (e) => {
        e.stopPropagation();
        onClear && onClear();
    };

    return (
        <div className={chipClasses} onClick={onClick}>
            <FontAwesomeIcon className="m-r-6" icon={icon} />
            {value ? <span>{`${value} Filter(s)`}</span> : <span>{label}</span>}
            {value && <FontAwesomeIcon onClick={handleClear} className="m-l-12 cursor-pointer" icon={faClose} />}
        </div>
    );
};
